import { CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';

export const shouldPreventChangingMinimalBasketRequirement = (country: Country, campaignType: CampaignType) => {
  return country === 'ISR' && [CampaignType.BASKET_DISCOUNT, CampaignType.ITEM_DISCOUNT].includes(campaignType);
};
